import React from "react";
import SocialBar from "./SocialBar";
import DarkModeToggle from "./DarkModeToggle";
import Footer from "../layout/Footer";

import Header from "../layout/Header";

const LayoutNoVideo = ({ children }) => {
    return (
        <div className="relative min-h-screen flex flex-col text-white bg-lightGreen dark:bg-[#0a1a1a]">
            {/* Social + Toggle */}
            <SocialBar />
            <DarkModeToggle />

            {/* Contenedor para alinear Link y Header */}
            <Header />

            {/* Contenido principal */}
            <main className="flex-1 flex justify-center items-center px-6 py-16">
                {children}
            </main>

            <Footer />
        </div>
    );
};

export default LayoutNoVideo;
